import React from "react";
import { Form, Input, Checkbox, DatePicker } from "antd";
import moment from "moment";
import { isNumeric } from "../../../../../common/utils/validation";

const PhysicalForm = props => {
  const requiredRule = {
    required: true,
    message: "Поле, обязательное для заполнения"
  };
  const { form, disabled } = props;
  const { getFieldDecorator, getFieldValue } = form;
  const birthDate = getFieldValue("birthDate");
  const hasNoPatronymic = getFieldValue("hasNoPatronymic");
  return (
    <div className="customer-card-form__physical">
      <div className="customer-card-form__main-block">
        <div className="customer-card-form__unit">
          <span className="customer-card-form__label">Фамилия:</span>
          <div className="customer-card-form__item">
            <Form.Item>
              {getFieldDecorator("lastname", {
                rules: [requiredRule]
              })(
                <Input
                  disabled={disabled}
                  className="customer-card-form__input"
                  placeholder="Укажите фамилию"
                  style={{ width: "224px" }}
                />
              )}
            </Form.Item>
          </div>
        </div>
        <div className="customer-card-form__unit">
          <span className="customer-card-form__label">Имя:</span>
          <div className="customer-card-form__item">
            <Form.Item>
              {getFieldDecorator("name", {
                rules: [requiredRule]
              })(
                <Input
                  disabled={disabled}
                  className="customer-card-form__input"
                  placeholder="Укажите имя"
                  style={{ width: "224px" }}
                />
              )}
            </Form.Item>
          </div>
        </div>
        <div className="customer-card-form__unit">
          <span className="customer-card-form__label">Отчество:</span>
          <div className="customer-card-form__item">
            <Form.Item>
              {/*здесь надо подумать как назначить валидацию. Нужно обсудить в Серёжей*/}
              {getFieldDecorator("patronymic")(
                <Input
                  className="customer-card-form__input"
                  placeholder="Укажите отчество"
                  disabled={
                    (!!hasNoPatronymic && hasNoPatronymic.value) || disabled
                  }
                  style={{ width: "224px" }}
                />
              )}
            </Form.Item>
            {!disabled &&
              getFieldDecorator("hasNoPatronymic", {
                valuePropName: "hasNoPatronymic"
              })(
                <Checkbox className="customer-card-form__after">
                  Нет отчества
                </Checkbox>
              )}
          </div>
        </div>
        <div className="customer-card-form__unit">
          <span className="customer-card-form__label">Дата рождения:</span>
          <div className="customer-card-form__item">
            <Form.Item>
              {getFieldDecorator("birthDate", {
                rules: [requiredRule]
              })(
                <DatePicker
                  placeholder="ДД.ММ.ГГГГ"
                  style={{ width: "224px" }}
                  disabled={disabled}
                  defaultPickerValue={moment().subtract(18, "years")}
                  format={"DD.MM.YYYY"}
                  disabledDate={d => {
                    return !moment()
                      .subtract(18, "years")
                      .isAfter(d);
                  }}
                />
              )}
            </Form.Item>
            <span className="customer-card-form__label">
              {birthDate && moment(birthDate).fromNow(true)}
            </span>
          </div>
        </div>
        <div className="customer-card-form__unit">
          <span className="customer-card-form__label">Место рождения:</span>
          <div className="customer-card-form__item">
            <Form.Item>
              {getFieldDecorator("birthPlace")(
                <Input
                  disabled={disabled}
                  className="customer-card-form__input"
                  placeholder="Укажите место рождения"
                  style={{ width: "368px" }}
                />
              )}
            </Form.Item>
          </div>
        </div>
        <div className="customer-card-form__unit double-margin">
          <span className="customer-card-form__label">Серия паспорта:</span>
          <div className="customer-card-form__item">
            <Form.Item>
              {getFieldDecorator("passportSeries", {
                rules: [
                  {
                    validator: (rule, value, callback) => {
                      if (value && !isNumeric(value)) {
                        callback("Недопустимый символ");
                      } else {
                        callback();
                      }
                    }
                  }
                ]
              })(
                <Input
                  disabled={disabled}
                  className="customer-card-form__input"
                  placeholder="Укажите серию паспорта"
                  maxLength={4}
                  style={{ width: "224px" }}
                />
              )}
            </Form.Item>
          </div>
        </div>
        <div className="customer-card-form__unit">
          <span className="customer-card-form__label">Номер паспорта:</span>
          <div className="customer-card-form__item">
            <Form.Item>
              {getFieldDecorator("passportNumber", {
                rules: [
                  {
                    validator: (rule, value, callback) => {
                      if (value && !isNumeric(value)) {
                        callback("Недопустимый символ");
                      } else {
                        callback();
                      }
                    }
                  }
                ]
              })(
                <Input
                  disabled={disabled}
                  className="customer-card-form__input"
                  placeholder="Укажите номер паспорта"
                  maxLength={6}
                  style={{ width: "224px" }}
                />
              )}
            </Form.Item>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhysicalForm;
